import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=25b76b85&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=25b76b85&prod&scoped=true&lang=scss"
import style1 from "./AlertsTable.vue?vue&type=style&index=1&id=25b76b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b76b85",
  null
  
)

export default component.exports